<template>
    <div class="card card-custom" :class="[bgClass, colorClass, shadowClass]">
        <div v-if="$slots.title || $slots.toolbar || $slots.header_custom"
             class="card-header py-4"
             :class="{'container-sm': slimContent}">
            <Center v-if="$slots.header_custom" vertical :class="[colorClass]">
                <slot name="header_custom"/>
            </Center>
            <Center v-else vertical>
                <div class="card-title m-0 mt-1">
                    <span v-if="$slots.icon" class="card-icon font-size-h1" :class="[colorClass]">
                        <slot name="icon"/>
                    </span>
                    <div class="d-flex flex-column">
                        <div class="card-label font-size-h4 font-weight-bold m-0" :class="[colorClass]">
                            <slot name="title"/>
                        </div>
                        <div v-if="$slots.description" class="font-weight-light font-size-sm mt-n1"
                             :class="[{'text-muted':colorClass===null}, colorClass]">
                            <slot name="description"/>
                        </div>
                    </div>
                </div>
            </Center>
            <div v-if="$slots.toolbar" class="card-toolbar">
                <slot name="toolbar"/>
            </div>
        </div>
        <div class="card-body" :class="{'container-sm': slimContent}">
            <slot/>
        </div>
        <div v-if="$slots.footer" class="card-footer" :class="{'container-sm': slimContent}">
            <slot name="footer"/>
        </div>
    </div>
</template>

<script>
import Center from '@components/Layout/Center.vue';

export default {
    components: {Center},

    props: {
        slimContent: Boolean,
        type: String,
        shadow: {
            type: String,
            default: null
        }
    },

    computed: {
        bgClass() {
            if (this.type) {
                return `bg-${this.type}`;
            }

            return null;
        },

        colorClass() {
            if (this.type) {
                return 'text-white';
            }

            return null;
        },

        shadowClass() {
            if (this.shadow != null && this.shadow.length > 0) {
                return `shadow-${this.shadow}`;
            }

            return null;
        }
    }
};
</script>
